// Lightweight fetch wrappers — every API call routes through here so
// the CSRF token + JSON headers are uniform. The token comes from the
// dashboard's bootstrap payload (see app/helpers/dashboards_helper.rb).

let csrfToken = null

export function setCsrfToken(token) { csrfToken = token }

async function request(method, url, body) {
  const headers = { "Accept": "application/json" }
  if (body !== undefined) headers["Content-Type"] = "application/json"
  if (csrfToken && method !== "GET") headers["X-CSRF-Token"] = csrfToken

  const res = await fetch(url, {
    method,
    headers,
    credentials: "same-origin",
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
  const text = await res.text()
  const json = text ? safeParse(text) : null
  if (!res.ok) {
    const err = new Error((json && json.error) || `HTTP ${res.status}`)
    err.status = res.status
    err.payload = json
    throw err
  }
  return json
}

function safeParse(t) {
  try { return JSON.parse(t) } catch { return null }
}

export const api = {
  get:  (url)        => request("GET",  url),
  post: (url, body)  => request("POST", url, body),
  put:  (url, body)  => request("PUT",  url, body),
  del:  (url)        => request("DELETE", url),
}
